module.exports = __webpack_public_path__ + "img/iconW.63c59595.png";